/* eslint-disable sonarjs/no-duplicate-string */
import { FC } from "react";

import { Stack } from "@mui/material";

import { PeerToPeerDonateCampaignAction } from "./PeerToPeerDonateCampaignAction";
import { PeerToPeerPrimaryCampaignFundraiseCampaignAction } from "./PeerToPeerPrimaryCampaignFundraiseCampaignAction";
import { PeerToPeerRegisterCampaignAction } from "./PeerToPeerRegisterCampaignAction";

import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
import { FormTypography } from "@/forms-design-system/FormTypography";
import { useTranslate } from "@/hooks/useTranslate";

export type PeerToPeerPrimaryCampaignActionsProps = {
  allowTeamCreation: boolean;
  allowFundraiserCreation: boolean;
  hasRegistration: boolean;
  onDonateButtonClick?: () => void;
  onFundraiseButtonClick?: () => void;
  onRegisterButtonClick?: () => void;
  shouldHideFundraise?: boolean;
};

export const PeerToPeerPrimaryCampaignActions: FC<PeerToPeerPrimaryCampaignActionsProps> = ({
  allowTeamCreation,
  allowFundraiserCreation,
  hasRegistration,
  onFundraiseButtonClick,
  onDonateButtonClick,
  onRegisterButtonClick,
  shouldHideFundraise,
}) => {
  const { t } = useTranslate();
  const isGhostPreview = useIsGhostPreview("PeerToPeerPrimaryCampaignActions");

  return (
    <Stack
      gap={2}
      id="p2p-primary-campaign-actions"
      sx={{
        ...(isGhostPreview && {
          opacity: GHOST_PREVIEW_OPACITY,
        }),
      }}
    >
      <FormTypography variant="h6" vibe="intense">
        {t("donationForm", "peerToPeer.howDoYouWantToContribute")}
      </FormTypography>
      <PeerToPeerDonateCampaignAction
        canDonateToTeamCampaign={allowTeamCreation}
        canDonateToIndividualCampaign={allowFundraiserCreation}
        onClick={onDonateButtonClick}
      />
      {hasRegistration && (
        <PeerToPeerRegisterCampaignAction
          canCreateTeamCampaigns={allowTeamCreation}
          canCreateIndividualCampaigns={allowFundraiserCreation}
          onClick={onRegisterButtonClick}
        />
      )}
      {!shouldHideFundraise && (
        <PeerToPeerPrimaryCampaignFundraiseCampaignAction
          canCreateTeamCampaigns={allowTeamCreation}
          canCreateIndividualCampaigns={allowFundraiserCreation}
          hasRegistration={hasRegistration}
          onClick={onFundraiseButtonClick}
        />
      )}
    </Stack>
  );
};
